<template>
    <div
        v-if="videoData"
        class="h-full w-full"
    >
        <div
            class="rounded-card-md relative h-full w-full overflow-hidden"
            :style="customHeight"
            :class="{
                'min-h-[250px]': block.Height === 'auto',
            }"
        >
            <LazyVideoPlayer
                ref="video"
                :title="block.Text ?? ''"
                :alignment="block.TextPosition"
                :options="options"
                :popup-playback="!!block.PopupPlayback"
                class="relative aspect-video w-full"
                rounded
            />
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        id: String,
        block: Object,
        isSingleton: Boolean,
    })

    const video = ref(null)

    const imageData = ref(first(props.block.CoverImage))
    const videoData = ref(first(props.block.Video))

    const customHeight = computed(() => {
        if (props.block?.Height !== 'custom') {
            return ''
        }

        return {
            height: `${props.block?.CustomHeight}px`,
        }
    })

    const options = ref({
        autoplay: false,
        muted: false,
        volume: 0.5,
        controls: false,
        loop: true,
        src: videoData.value?.videoType === 'file' ? videoData.value?.videoFile?.[0]?.url : videoData.value?.videoUrl,
        poster: imageData.value.url,
        load: 'visible',
        log: 'silent',
    })
</script>
